module.exports = __webpack_public_path__ + "img/pwa-mac-1.33b21e44.jpeg";